const API_HOST = process.env.VUE_APP_API_HOST;
const CORE_API_HOST = `${API_HOST}/core/v1/resource`;
const TERRA_API_HOST = `${API_HOST}/terra/v1/resource`;
const GIS_API_HOST =  process.env.VUE_APP_GIS_API_HOST;
const TICKETS_API_HOST = `${API_HOST}/tasks/v1/resource`;
const VAULT_API_HOST = `${API_HOST}/dms/v1/resource`;
const FORMS_API_HOST = `${API_HOST}/forms/v1/resource`;

export {
    CORE_API_HOST,
    TERRA_API_HOST,
    TICKETS_API_HOST,
    VAULT_API_HOST,
    FORMS_API_HOST,
    GIS_API_HOST
}